import React from 'react';
import Icon from '../../../components/AppIcon';
import departmentalBudgetService from '../../../services/departmentalBudgetService';

const PayrollCostAnalysis = ({ payrollBreakdown }) => {
  if (!payrollBreakdown || payrollBreakdown?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 text-center">
        <Icon name="DollarSign" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3" />
        <p className="text-muted-foreground">No payroll cost data available</p>
      </div>
    );
  }

  const latestBreakdown = payrollBreakdown?.[0];

  return (
    <div className="space-y-4">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground">Payroll Cost Breakdown</h3>
          <span className="text-sm text-muted-foreground">
            {latestBreakdown?.periodStart} to {latestBreakdown?.periodEnd}
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Users" size={18} color="var(--color-primary)" />
              <span className="text-sm text-muted-foreground">Employee Count</span>
            </div>
            <p className="text-2xl font-heading font-bold text-foreground">{latestBreakdown?.employeeCount}</p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="TrendingUp" size={18} color="var(--color-success)" />
              <span className="text-sm text-muted-foreground">Total Gross</span>
            </div>
            <p className="text-2xl font-heading font-bold text-foreground">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalGrossKina)}
            </p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Wallet" size={18} color="var(--color-primary)" />
              <span className="text-sm text-muted-foreground">Total Net</span>
            </div>
            <p className="text-2xl font-heading font-bold text-foreground">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalNetKina)}
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between py-2 border-b border-border">
            <span className="text-sm text-muted-foreground">SWT (Salary & Wages Tax)</span>
            <span className="font-medium text-foreground">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalSwtKina)}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 border-b border-border">
            <span className="text-sm text-muted-foreground">NASFUND (Employee)</span>
            <span className="font-medium text-foreground">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalNasfundEmployeeKina)}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 border-b border-border">
            <span className="text-sm text-muted-foreground">NASFUND (Employer)</span>
            <span className="font-medium text-foreground">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalNasfundEmployerKina)}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 border-b border-border">
            <span className="text-sm text-muted-foreground">Total Allowances</span>
            <span className="font-medium text-success">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalAllowancesKina)}
            </span>
          </div>

          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-muted-foreground">Total Deductions</span>
            <span className="font-medium text-error">
              {departmentalBudgetService?.formatKina(latestBreakdown?.totalDeductionsKina)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollCostAnalysis;